module.exports = __webpack_public_path__ + "img/Character_Beidou_Thumb.2205006a.png";